import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import FetchApi from '../../../customhooks/functionFetchApi_erp';
import { FaSearch } from "react-icons/fa";
import DataTable from 'react-data-table-component';

function TableGroupItem({ data, hendleModel, groupItemset }) {

    const SelectGruop = (itemid, Itemname) => {
        hendleModel(false)
        groupItemset(itemid, Itemname)
    }

    const columns = [
        {
            name: 'ITEM ID',
            sortable: true,
            selector: row => row.itemid,
            grow: 1
        },
        {
            name: 'ITEM NAME',
            selector: row => row.Itemname,
            grow: 2
        },
        {
            name: 'เลือกกุล่ม',
            selector: row => <div>
                <Button variant="primary" size='sm' onClick={() => SelectGruop(row.itemid, row.Itemname)}>คลิกเลือก</Button>
                {/* <button onClick={()=>hendleModel(false)}>คลิกเลือก</button> */}
            </div>,
        },
    ];

    const customStyles = {
        headRow: {
            style: {
                border: 'none',
                backgroundColor: '#28B463'
            },
        },
        headCells: {
            style: {
                color: '#ffff',
                fontSize: '14px',
            },
        },
        // rows: {
        //     highlightOnHoverStyle: {
        //         backgroundColor: 'rgb(230, 244, 244)',
        //         borderBottomColor: '#FFFFFF',
        //         borderRadius: '25px',
        //         outline: '1px solid #FFFFFF',
        //     },
        // },
        // pagination: {
        //     style: {
        //         border: 'none',
        //     },
        // },
    };

    return (
        <DataTable
            columns={columns}
            data={data}
            // selectableRows
            pagination
            customStyles={customStyles}
            highlightOnHover

        />
    )
}




function Popupitemgroupcolor(props) {

    const FetchApis = new FetchApi();
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [groupitems, setGroupitems] = useState([]);
    const [textSearch, setTextSearch] = useState()

    useEffect(() => {

        getapilist()

    }, [])

    const getapilist = () => {
        FetchApis.FethcGet(`getItemInkcolor`).then((res) => {
            // console.log(res.status)
            if (res.status == 200) {

                setGroupitems(res.data.listall)
                setTextSearch(res.data.listall);
            }
        })
    }

    const hendleModel = (value) => {
        setShow(false)
    }

    const onSearchText = (datavalue) => {

        const filteredData = textSearch.filter((item) => {
            return Object.values(item).join('').toLowerCase().includes(datavalue.toLowerCase())
        })

        setGroupitems(filteredData)
    }
    const groupItemset = (itemid, Itemname) => {

        // props.props(v)
        if (props.typeink == 'ink21') {
            props.OnChangDatacolor2(itemid, Itemname)
        }
        else if (props.typeink == 'ink22') {
            props.OnChangDatacolor2_(itemid, Itemname)
        }
        else if (props.typeink == 'ink61') {
            props.OnChangDatacolor6(itemid, Itemname)
        }
        else if (props.typeink == 'ink62') {
            props.OnChangDatacolor6(itemid, Itemname)
        } else if (props.typeink == 'ink71') {
            props.OnChangDatacolor7(itemid, Itemname)
        }else if(props.typeink == 'ink72'){
            props.OnChangDatacolor7_(itemid, Itemname)
        }
        else if(props.typeink == 'ink81'){
            props.OnChangDatacolor8(itemid, Itemname)
        }

        getapilist()

    }

    return (
        <div>
            <FaSearch variant="primary" onClick={handleShow} size={20}>
                Launch demo modal
            </FaSearch>

            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Item group</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="ค้นหา ป้อนข้อมูล" size='sm' onChange={(e) => onSearchText(e.target.value)} />
                        </Form.Group>
                    </Form>

                    {
                        groupitems.length > 0 && <TableGroupItem data={groupitems} hendleModel={hendleModel} groupItemset={groupItemset} />
                    }

                </Modal.Body>
            </Modal>

        </div>
    )
}

export default Popupitemgroupcolor